export default {"src":"/_next/static/media/smoke_detector.a17b2a90.svg","height":100,"width":100};